module.exports = require("@swa-ui/core/src/Fade/Fade.module.scss");